package sarka.design.skoria.ui.composables

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.ui.tooling.preview.Preview
import sarka.design.skoria.model.ChatStatus
import sarka.design.skoria.model.ChatUiState
import sarka.design.skoria.ui.VideoView
import sarka.design.skoria.ui.theme.RCTheme
import sarka.design.skoria.webrtc.PlatformVideoTrack

@Composable
fun AndroidCore(
    padding: PaddingValues,
    local: PlatformVideoTrack?,
    remote: PlatformVideoTrack?,
    onSkip: () -> Unit,
    state: ChatUiState,
) {
    Column(
        modifier = Modifier
            .padding(padding)
            .fillMaxSize()
    ) {
        Box(modifier = Modifier.weight(1f)
            .fillMaxSize()
        ) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(horizontal = 8.dp, vertical = 4.dp)
                    .testTag("col_left")
            ) {
                Box(
                    modifier = Modifier.weight(1f)
                        .fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    VideoView(track = remote, mirror = false, muted = true)
                    SkoriaRerollText()
                }

                Spacer(Modifier.height(8.dp))

                Box(
                    modifier = Modifier.weight(1f)
                        .fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    VideoView(track = local, mirror = true, muted = true)
                }

                // 🔹 Small skip button
                IconButton(
                    onClick = onSkip,
                    enabled = state.status != ChatStatus.WAITING_FOR_PARTNER,
                    colors = IconButtonDefaults.iconButtonColors(
                        contentColor = RCTheme.colors.onSurface,
                        disabledContentColor = RCTheme.colors.onSurface.copy(alpha = 0.38f)
                    )
                ) {
                    Icon(
                        modifier = Modifier.size(48.dp),
                        imageVector = Icons.Default.Refresh,
                        contentDescription = "Skip",
                    )
                }
            }
        }
        Box(modifier = Modifier.weight(0.4f)
            .fillMaxSize()
        ) {
            LazyColumn(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(8.dp)
                    .testTag("col_right"),
                verticalArrangement = Arrangement.spacedBy(6.dp)
            ) {
                items(state.messages) { msg ->
                    val prefix = if (msg.fromMe) "You: " else "Partner: "
                    val cardColor = if (msg.fromMe)
                        RCTheme.colors.primary
                    else
                        RCTheme.colors.surfaceVariant
                    val textColor = if (msg.fromMe)
                        RCTheme.colors.onPrimary
                    else
                        RCTheme.colors.onSurface

                    Card(
                        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp),
                        colors = CardDefaults.cardColors(containerColor = cardColor)
                    ) {
                        SelectionContainer{
                            Text(
                                text = prefix + msg.text,
                                color = textColor,
                                modifier = Modifier.padding(horizontal = 12.dp, vertical = 8.dp)
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
@Preview
fun AndroidCorePreview() {
    RCTheme {
        AndroidCore(
            padding = PaddingValues(),
            local = null,
            remote = null,
            onSkip = {},
            state = ChatUiState()
        )
    }
}